import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import * as constants from "./constants";
import * as helpers from "./helpers";
export class IPadSettingsController {
    constructor(props) {
        this.response = {};
        this.uiMessage = props.uiMessage;
        this.pageMethods = props.pageMethods;
        this.isFirstVisit = props.isFirstVisit;
        this.window = props.window;
        this.internalBus = props.internalMessageBus;
        this.init();
    }
    init() {
        this.pageMethods.GetIPadDomainConfigurationSettings(this.getResponse.bind(this));
    }
    getResponse(response) {
        //JSON.parse does not work for page methods due to the specific of the response format
        this.response = eval(response);
        if (this.response.status === "error") {
            return;
        }
        this.response.isFirstLoadPopUpEnabled && this.isFirstVisit && this.showMessageOnFirstLoad();
        this.response.isLoginPopUpEnabled &&
            this.subscribe(InternalMessageBusChannels.iPadSettingsController.onFirstLogin, this.showMessageOnLogin);
    }
    subscribe(channel, callback) {
        this.internalBus.on(channel, callback, this);
    }
    createMessage(enableGraphics, content, btnTxt) {
        const btn = btnTxt ? btnTxt : constants.btnTxt;
        const txt = enableGraphics ? `${content}${constants.imgHtml}` : content;
        this.showMessage(btn, txt);
    }
    showMessageOnFirstLoad() {
        const { firstLoadPopUpBtnTxt, firstLoadPopUpMsgContent, isFirstLoadPopUpImgsEnabled } = this.response;
        const content = helpers.buildContent(firstLoadPopUpMsgContent);
        this.window.addEventListener("load", () => {
            this.createMessage(isFirstLoadPopUpImgsEnabled, content, firstLoadPopUpBtnTxt);
        });
    }
    showMessageOnLogin(data) {
        const { loginPopUpBtnTxt, loginPopUpMsgContent, isLoginPopUpImgsEnabled } = this.response;
        const content = helpers.buildContent(loginPopUpMsgContent);
        this.createMessage(isLoginPopUpImgsEnabled, content, loginPopUpBtnTxt);
    }
    showMessage(btnTxt, content) {
        this.uiMessage.show({
            body: content,
            hasOverlay: true,
            type: "notification",
            actions: {
                accept: {
                    text: btnTxt
                }
            },
            afterShowCallback: helpers.addCustomClass
        });
    }
}
//# sourceMappingURL=IPadSettingsController.js.map